import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.25 10.512a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M12 8.262a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m12 21.762-.36.657-.004-.001-.005-.004-.02-.01-.071-.041q-.091-.053-.255-.153a19.6 19.6 0 0 1-3.571-2.87c-1.946-1.993-3.964-4.983-3.964-8.83a8.25 8.25 0 1 1 16.5 0c0 3.846-2.02 6.836-3.963 8.827a19.6 19.6 0 0 1-2.682 2.282 17 17 0 0 1-1.145.742l-.07.04-.02.011-.006.004h-.002s-.002.001-.362-.656m0-18a6.75 6.75 0 0 0-6.75 6.75c0 3.296 1.73 5.93 3.537 7.779a18 18 0 0 0 3.213 2.6 18 18 0 0 0 3.214-2.598c1.805-1.85 3.536-4.483 3.536-7.78A6.75 6.75 0 0 0 12 3.762",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m12 21.762.36.657a.75.75 0 0 1-.72 0z"
    }, null, -1)
  ])))
}
export default { render: render }